// extracted by mini-css-extract-plugin
export default {"root":"Header_root__KkSbk","back":"Header_back__C7M14"};